export default "__VITE_ASSET__1865d92e__"